import {
  Flex,
  Menu,
  MenuItem,
  MenuItemProps,
  MenuProps,
} from '@chakra-ui/react';
import React from 'react';
import { useBreakpointValue } from '~/utils-ts';

import { DropdownAsModal } from './DropdownAsModal';

export const DropdownItem: React.FC<MenuItemProps> = (props) => (
  <MenuItem
    p={4}
    fontSize="md"
    _focus={{ backgroundColor: 'gray.50' }}
    {...props}
  />
);

interface Props extends MenuProps {
  isModalOnMobile?: boolean;
}

export const Dropdown = React.forwardRef<HTMLDivElement, Props>(
  ({ isModalOnMobile = true, ...rest }, ref) => {
    const isMobileView = useBreakpointValue({ base: true, md: false });

    if (isMobileView && isModalOnMobile) {
      // @ts-ignore
      return <DropdownAsModal {...rest} />;
    }

    return (
      <Flex position="relative" shrink={0} ref={ref}>
        <Menu isLazy {...rest} />
      </Flex>
    );
  },
);
